import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

const StyledChip = styled(Chip)(({ statusRequest }) => ({
  height: 24,
  ...(statusRequest === 1 && {
    backgroundColor: "#ebfaf2",
  }),
  ...(statusRequest === 2 && {
    backgroundColor: "#fdf3f5",
  }),
  ...(statusRequest === 0 && {
    backgroundColor: "#fffcd6",
  }),
}));

const StatusRequest = ({ status }) => {
  const { t, i18n } = useTranslation();

  const renderIcon = (status) => {
    if (status === 1) {
      return (
        <i
          className={`fas fa-check-circle`}
          style={{ fontSize: 16, color: "#00c292" }}
        ></i>
      );
    } else if (status === 2) {
      return (
        <i
          className={`fas fa-times-circle`}
          style={{ fontSize: 16, color: "#e46a76" }}
        ></i>
      );
    } else {
      return (
        <i
          className={`fas fa-question-circle`}
          style={{ fontSize: 16, color: "#fec90f" }}
        ></i>
      );
    }
  };

  const renderStatusText = (status) => {
    if (status === 1) {
      return (
        <Typography
          style={{ fontSize: 12, fontWeight: "500", color: "#00c292" }}
        >
          {t("Approve")}
        </Typography>
      );
    } else if (status === 2) {
      return (
        <Typography
          style={{ fontSize: 12, fontWeight: "500", color: "#e46a76" }}
        >
          {t("Disapproval")}
        </Typography>
      );
    } else {
      return (
        <Typography
          style={{ fontSize: 12, fontWeight: "600", color: "#fec90f" }}
        >
          {t("WaitingApproval")}
        </Typography>
      );
    }
  };

  return <StyledChip label={renderStatusText(status)} statusRequest={status} />;
};

export default StatusRequest;
